/**
 * 根据date获得时间
 */
import i18n from '@i18next/i18n';

// eslint-disable-next-line complexity
export function timeDateFormat(time) {
    if (!time) {
        return '';
    }

    let date: Date|null = null;
    if (time instanceof String) {
        const a = time.replace(/\s+/, '').split(/[^0-9]/);
        if (a.length >= 5) {
            date = time
                ? new Date(Number(a[0]), Number(a[1]) - 1, Number(a[2]), Number(a[3]), Number(a[4]))
                : new Date();
        } else {
            date = time ? new Date(Number(time)) : new Date();
        }
    } else {
        date = time ? new Date(time) : new Date();
    }

    if (date instanceof Date) {
        if (date.toDateString() === new Date().toDateString()) { // 当天显示时分
            return [
                date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`,
                ':',
                date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`,
            ].join('');
        }
        return [
            date.getFullYear(),
            i18n.t('年'),
            date.getMonth() + 1,
            i18n.t('月'),
            date.getDate(),
            i18n.t('日'),
            date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`,
            ':',
            date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`,
        ].join('');
    }
    return '';
}

/**
 * 根据date完整时间
 */
export function fullDateFormat(date) {
    if (date instanceof Date) {
        return [date.getFullYear(), i18n.t('年'), date.getMonth() + 1, i18n.t('月'), date.getDate(), i18n.t('日'),
            date.getHours() > 9 ? date.getHours() : (`0${date.getHours()}`), ':',
            date.getMinutes() > 9 ? date.getMinutes() : (`0${date.getMinutes()}`), ':',
            date.getSeconds() > 9 ? date.getSeconds() : (`0${date.getSeconds()}`)].join('');
    }
    if (date.toString()) {
        return date.toString();
    }
    return '';
}
/**
 * 根据date展示年月
 */
export function dateFormatYM(date) {
    if (date instanceof Date) {
        return [date.getFullYear(), i18n.t('年'), date.getMonth() + 1, i18n.t('月')].join('');
    }
    if (date.toString()) {
        return date.toString();
    }
    return '';
}
/**
 * 根据date展示月日
 */
export function dateFormatMD(date) {
    if (date instanceof Date) {
        return [date.getMonth() + 1, i18n.t('月'), date.getDate(), i18n.t('日')].join('');
    }
    if (date.toString()) {
        return date.toString();
    }
    return '';
}
/**
 * 根据date展示时分
 */
export function dateFormatHM(date) {
    if (date instanceof Date) {
        return [date.getHours() > 9 ? date.getHours() : (`0${date.getHours()}`), ':',
            date.getMinutes() > 9 ? date.getMinutes() : (`0${date.getMinutes()}`)].join('');
    }
    if (date.toString()) {
        return date.toString();
    }
    return '';
}
